export const userRoles = function () {
    /**
   * findUserRoles() // DON'T CALL THIS METHOD FOR PAGE LABEL, THIS METHOD USED FOR HIDE THE NAVIGATION BASED ON USER ROLE DEFINED
   * @param {Object} navigationMenu // Form Data, Create or Update
   * @returns Object
   */
    function findUserRoles(navigationMenu) {
        let rolesPermission
        if (!navigationMenu) {
            return
        }

        const userData = findLocalStorageData()

        if (!userData && !userData?.permissions) {
            return
        }
        rolesPermission = navigationMenu?.map((subModule) => {
            const updatedModule = userData?.permissions?.find(
                ({ activity_id }) => activity_id === subModule?.activity_id
            )
            return updatedModule ? { ...subModule, ...updatedModule } : subModule
        })

        

        //Note: DON"T REMOVE BELOW COMMENTED CODE, ONCE CHANGES APPLIED IN ENTIRE PAGE, THEN WILL REMOVE THIS CODE
        // const response =
        //   navigationMenu &&
        //   navigationMenu.map((subModule) => {
        //     const updatedModule = userData.activities.filter(
        //       ({ sub_module_name }) => sub_module_name === subModule?.activity_id
        //     )[0];
        //     return updatedModule ? { ...subModule, ...updatedModule } : subModule;
        //   });
        // rolesPermission =
        //   response &&
        //   response.map((roles) => {
        //     const updatedModule = userData.permissions.find(
        //       ({ activity_id }) => activity_id === roles.activity_id
        //     );
        //     return updatedModule ? { ...roles, ...updatedModule } : roles;
        //   });

        return rolesPermission
    }

    /**
   * findUserRolesForPage()  CHECK ROLES FOR PAGE LABEL PASS STRING AS "SUB_MODULE_NAME" ASN BASED ON THAT RETURN THE PERMISSION
   *@param {String}
   *
   */
    function findUserRolesForPage(activityIid) {
        const userData = findLocalStorageData()
        if (!userData) {
            return
        }

        return userData?.permissions?.find(({ activity_id }) => {
            if(Array.isArray(activity_id)){
                activity_id.includes(activityIid)
            } else {
                return activity_id === activityIid
            }      
        })
    }

    function findUserAllPermission() {
        const userData = findLocalStorageData()
        if (!userData) {
            return
        }
        return userData?.permissions
    }

    // HELPER METHOD TO RETRIVE LOCAL STORAGE DATA

    const findLocalStorageData = () => {
        const cachedData = sessionStorage.getItem("userDetails")
        if (!cachedData) {
            return
        }

        return JSON.parse(cachedData)
    }

    return {
        findUserRoles,
        findUserRolesForPage,
        findUserAllPermission
    }
}
